/** Start a manual Stripe payment flow for the remaining balance on an invoice. */
export const tenantBillingInvoicePaymentInitiateSpec = {
    uri: '/t/[tenant]/billing/invoice/[invoice]/payment/initiate',
    method: 'POST',
};
